import { render, staticRenderFns } from "./AdminViewsList.vue?vue&type=template&id=185ed8b8&scoped=true"
import script from "./AdminViewsList.vue?vue&type=script&lang=js"
export * from "./AdminViewsList.vue?vue&type=script&lang=js"
import style0 from "./AdminViewsList.vue?vue&type=style&index=0&id=185ed8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ed8b8",
  null
  
)

export default component.exports